export const noCoverOption = {
  description: 'I Don’t need any, thanks',
  code: 'none',
  amountInPounds: 0,
  name: 'tier',
  amount: 0,
  category: 'false',
  selected: false,
}
